const USER_STATUS = {
  ACTIVE: 1,
  CONFIRMING: 0,
  INACTIVE: 2,
};

export { USER_STATUS };
